/* tslint:disable */
/* eslint-disable */
/**
 * DynamicForms.Server | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the Background interface.
 */
export function instanceOfBackground(value) {
    return true;
}
export function BackgroundFromJSON(json) {
    return BackgroundFromJSONTyped(json, false);
}
export function BackgroundFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'useBackground': json['useBackground'] == null ? undefined : json['useBackground'],
        'background': json['background'] == null ? undefined : json['background'],
        'usePaper': json['usePaper'] == null ? undefined : json['usePaper'],
        'paper': json['paper'] == null ? undefined : json['paper'],
    };
}
export function BackgroundToJSON(json) {
    return BackgroundToJSONTyped(json, false);
}
export function BackgroundToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'useBackground': value['useBackground'],
        'background': value['background'],
        'usePaper': value['usePaper'],
        'paper': value['paper'],
    };
}
